import { GroupedAmenities } from "@/features/private-room/list/adapters/get-privateroom/get-privateroom.types";

export const EVENTS = {
  OUTLIER_DIALOG_VIEWED: "outlier_dialog_viewed",
  OUTLIER_DIALOG_CONFIRMED: "outlier_dialog_confirmed",
  OUTLIER_DIALOG_CANCELLED: "outlier_dialog_cancelled",
  CREATE_ROOM_SUCCESS: "create_room_success",
  UPDATE_ROOM_SUCCESS: "update_room_success",
  VIEW_PO_DETAIL_CLICKED: "view_po_detail_clicked",
  VIEW_PHOTO_CLICKED: "view_photo_clicked",
  SEARCH_SUBMITTED: "search_submitted",
  SEARCH_CLICKED: "search_clicked",
  CLEAR_SEARCH_CLICKED: "clear_search_clicked",
  SHOW_MAP_CLICKED: "show_map_clicked",
  AMENITY_CLICKED: "amenity_copied",
  ADDRESS_COPIED: "address_copied",
  NOTES_COPIED: "notes_copied",
  VIEW_PAGE_CLICKED: "view_page_clicked",
  VIEW_VIP_OFFICE_PAGE_CLICKED: "view_vip_office_page_clicked",
  EDIT_ROOM_CLICKED: "edit_room_clicked",
  SELECT_ROOM_CLICKED: "select_room_clicked",
  SELECT_ALL_ROOM_CLICKED: "select_all_room_clicked",
  CLICK_PRIVATEOFFICE_FILTER: "click_privateoffice_filter",
  LOADED_LIST_PRIVATEOFFICE: "loaded_list_privateoffice",
  CLICK_PRIVATEOFFICE_PROPOSAL_FINAL: "click_privateoffice_proposal_final",
  CLICK_PRIVATEOFFICE_PROPOSAL_START: "click_privateoffice_proposal_start",
  VISION_CLICK_PRIVATEOFFICE_PROPOSAL_FINAL:
    "vision_click_privateoffice_proposal_final",
  VISION_CLICK_PRIVATEOFFICE_PROPOSAL_START:
    "vision_click_privateoffice_proposal_start",
  EDIT_OTHER_INFO_CLICKED: "edit_other_info_clicked",
  CREATE_NEW_ROOM_CLICKED: "create_new_room_clicked",
  EDIT_ROOM_MODAL_SAVED: "edit_room_modal_saved",
  PAGE_VIEW: "page_view",
  SEARCH_CSV_UPLOAD: "search_csv_upload",
  SEARCH_CSV_UPLOAD_FAIL: "search_csv_upload_fail",
  SEARCH_CSV_RESULT_RETURNED: "search_csv_result_returned",
  SEARCH_PROMPT_SENT: "search_prompt_sent",
  SEARCH_PROMPT_RESULT_RETURNED: "search_prompt_result_returned",
  SEARCH_PROMPT_RESULT_FAIL: "search_prompt_result_fail",
  SEARCH_BUTTON_CLICKED: "search_button_clicked",
  SEARCH_RESULTS_RENDERED: "search_results_rendered",
  CREATE_PROPOSAL_CLICKED: "create_proposal_clicked",
  VISION_CREATE_PROPOSAL_CLICKED: "vision_create_proposal_clicked",
  IMPORT_CSV_BUTTON_CLICKED: "import_csv_button_clicked",
  IMPORT_CSV_SUCCESS: "import_csv_success",
  IMPORT_CSV_FAILED: "import_csv_failed",
  CREATE_PROPOSAL_FINISHED: "create_proposal_finished",
  VISION_CREATE_PROPOSAL_FINISHED: "vision_create_proposal_finished",
  VISION_PROPOSAL: "vision_proposal",
  VIEW_UPDATE_HISTORY_CLICKED: "view_update_history_clicked",
  SEARCH_FILTER_APPLIED: "search_filter_applied",
  UPDATE_ROOM_AMENITIES: "update_room_amenities",
  PRIVATE_ROOM_INFO_STARTED: "private_room_info_started",
  PRIVATE_ROOM_PHOTO_UPLOAD_STARTED: "private_room_photo_upload_started",
  PRIVATE_ROOM_PHOTO_UPLOAD_SUCCESS: "private_room_photo_upload_success",
  PRIVATE_ROOM_PHOTO_UPLOAD_ERROR: "private_room_photo_upload_error",
  PRIVATE_ROOM_PHOTO_TAG_SELECTED: "private_room_photo_tag_selected",
  CREATE_ROOM_ERROR: "create_room_error",
  UPDATE_ROOM_ERROR: "update_room_error",
  DRAFT_ROOM_SAVED: "draft_room_saved",
  SAVE_DRAFT_ERROR: "save_draft_error",
  VISION_SEARCH_FILTER_APPLIED: "vision_search_filter_applied",
  VISION_SEARCH_SUBMITTED: "vision_search_submitted",
  VISION_AMENITY_CLICKED: "vision_amenity_clicked",
  VISION_SEARCH_RESULTS_RENDERED: "vision_search_results_rendered",
  VISION_LONGLIST_FEEDBACK_SUBMITTED: "vision_longlist_feedback_submitted",
  VISION_LONGLIST_CONTINUE_CLICKED: "vision_longlist_continue_clicked",
  VISION_LONGLIST_PROPOSAL_START: "vision_longlist_proposal_start",
  VISION_AI_MODE_STARTED: "vision_ai_mode_started",
  VISION_AI_MODE_DIAGNOSIS_COMPLETED: "vision_ai_mode_diagnosis_completed",
  VISION_AI_MODE_LOCATION_COMPLETED: "vision_ai_mode_location_completed",
  VISION_AI_MODE_ADJUSTMENTS_COMPLETED: "vision_ai_mode_adjustments_completed",
  VISION_AI_MODE_IMAGES_COMPLETED: "vision_ai_mode_images_completed",
  VISION_AI_MODE_PROPOSAL_GENERATED: "vision_ai_mode_proposal_generated",
  VISION_AI_MODE_PROPOSAL_LINK_COPIED: "vision_ai_mode_proposal_link_copied",
  VISION_AI_MODE_PROPOSAL_OPENED: "vision_ai_mode_proposal_opened",
  VISION_AI_MODE_STEP_BACK: "vision_ai_mode_step_back",
  VISION_AI_MODE_DEAL_IMPORTED: "vision_ai_mode_deal_imported",
  VISION_AI_MODE_LOCATION_FILTER_APPLIED:
    "vision_ai_mode_location_filter_applied",
  VISION_AI_MODE_SPACE_DETAILS_VIEWED: "vision_ai_mode_space_details_viewed",
  VISION_AI_MODE_SPACE_SCORE_VIEWED: "vision_ai_mode_space_score_viewed",
  VISION_AI_MODE_VIEW_MODE_CHANGED: "vision_ai_mode_view_mode_changed",
  VISION_AI_MODE_LOCATION_SEARCH_STARTED:
    "vision_ai_mode_location_search_started",
  VISION_AI_MODE_LOCATION_SEARCH_SUCCESS:
    "vision_ai_mode_location_search_success",
  VISION_AI_MODE_LOCATION_SEARCH_NO_RESULTS:
    "vision_ai_mode_location_search_no_results",
  VISION_AI_MODE_LOCATION_SEARCH_ERROR: "vision_ai_mode_location_search_error",
  VISION_AI_MODE_LOCATION_SEARCH_NO_MATCH:
    "vision_ai_mode_location_search_no_match",
  VISION_AI_MODE_SEARCH_RESULTS_RENDERED:
    "vision_ai_mode_search_results_rendered",
  VISION_AI_MODE_PROPOSAL_EDIT_STARTED: "vision_ai_mode_proposal_edit_started",
  VISION_AI_MODE_PROPOSAL_EDIT_SAVED: "vision_ai_mode_proposal_edit_saved",
  VISION_AI_MODE_PROPOSAL_EDIT_CONFLICT:
    "vision_ai_mode_proposal_edit_conflict",
  VISION_PROPOSAL_VISIT_FLOW_STARTED: "vision_proposal_visit_flow_started",
  VISION_PROPOSAL_VISIT_WHEN_COMPLETED: "vision_proposal_visit_when_completed",
  VISION_PROPOSAL_VISIT_BACK_TO_WHEN: "vision_proposal_visit_back_to_when",
  VISION_PROPOSAL_VISITS_SCHEDULED: "vision_proposal_visits_scheduled",
  VISION_PROPOSAL_SPACE_SELECTED: "vision_proposal_space_selected",
  VISION_PROPOSAL_TAB_VIEWED: "vision_proposal_tab_viewed",
  VISION_PROPOSAL_SPACE_RATED: "vision_proposal_space_rated",
  VISION_PROPOSAL_SPACE_RATING_OPENED: "vision_proposal_space_rating_opened",
  VISION_PROPOSAL_SPACE_RATING_ABANDONED:
    "vision_proposal_space_rating_abandoned",
  VISION_PROPOSAL_SCHEDULE_VISIT_CLICKED:
    "vision_proposal_schedule_visit_clicked",
  // PED-12892 — measures the "test-drive" (1-day office trial) pilot.
  // Named after the tracking plan's DAY_USE_SELECTED row: fired when the
  // client PICKS the modality (not on submit — confirmation is already
  // covered by vision_proposal_visits_scheduled's per-visit `modality`).
  VISION_PROPOSAL_DAY_USE_SELECTED: "vision_proposal_day_use_selected",
  VISION_PROPOSAL_CHAT_MESSAGE_SENT: "vision_proposal_chat_message_sent",
  // "Fazer proposta" flow funnel — hub through submission.
  VISION_PROPOSAL_MAKE_PROPOSAL_STARTED:
    "vision_proposal_make_proposal_started",
  VISION_PROPOSAL_CONDITIONS_CHOICE_SELECTED:
    "vision_proposal_conditions_choice_selected",
  VISION_PROPOSAL_VALUE_NEGOTIATED: "vision_proposal_value_negotiated",
  VISION_PROPOSAL_ADJUSTMENTS_CHOICE_SELECTED:
    "vision_proposal_adjustments_choice_selected",
  VISION_PROPOSAL_ADJUSTMENT_TYPE_SELECTED:
    "vision_proposal_adjustment_type_selected",
  VISION_PROPOSAL_ADJUSTMENT_ADDED: "vision_proposal_adjustment_added",
  VISION_PROPOSAL_ADJUSTMENT_REMOVED: "vision_proposal_adjustment_removed",
  VISION_PROPOSAL_IDENTIFICATION_REACHED:
    "vision_proposal_identification_reached",
  VISION_PROPOSAL_SUBMITTED: "vision_proposal_submitted",
  // "Briefing aprofundado via proposta" (PED-14146) — measures
  // intentionality of clients who didn't find a fit among the listed
  // options, and which of the two flows they walked.
  VISION_PROPOSAL_BRIEFING_CARD_VIEWED: "vision_proposal_briefing_card_viewed",
  VISION_PROPOSAL_BRIEFING_STARTED: "vision_proposal_briefing_started",
  VISION_PROPOSAL_BRIEFING_STEP_ADVANCED:
    "vision_proposal_briefing_step_advanced",
  VISION_PROPOSAL_BRIEFING_SUBMITTED: "vision_proposal_briefing_submitted",
  VISION_PROPOSAL_CARD_PHOTO_BROWSED: "vision_proposal_card_photo_browsed",
  VISION_PROPOSAL_TALK_TO_BIA_CLICKED: "vision_proposal_talk_to_bia_clicked",
  VISION_PROPOSAL_MAP_DISTANCE_CALCULATED:
    "vision_proposal_map_distance_calculated",
  VISION_PROPOSAL_MAP_VIEWED: "vision_proposal_map_viewed",
  VISION_PROPOSAL_STEP_ADVANCED: "vision_proposal_step_advanced",
  VISION_PROPOSAL_MAP_POI_FILTERED: "vision_proposal_map_poi_filtered",
  VISION_PROPOSAL_ABANDONED: "vision_proposal_abandoned",
  VISION_PROPOSAL_SPACE_QUESTION: "vision_proposal_space_question",
  VISION_PROPOSAL_SHOWCASE_REORDERED: "vision_proposal_showcase_reordered",
  VISION_PROPOSAL_SHOWCASE_FILTERED: "vision_proposal_showcase_filtered",
  VISION_PROPOSAL_SHOWCASE_SCROLLED: "vision_proposal_showcase_scrolled",
  VISION_PROPOSAL_VALUE_PROP_VIEWED: "vision_proposal_value_prop_viewed",
  VISION_PROPOSAL_VALUE_MODE_TOGGLED: "vision_proposal_value_mode_toggled",
  VISION_PROPOSAL_HOURS_INFO_VIEWED: "vision_proposal_hours_info_viewed",
  VISION_PROPOSAL_VIEW_MODE_TOGGLED: "vision_proposal_view_mode_toggled",
  VISION_PROPOSAL_MAP_LAYERS_TOGGLED: "vision_proposal_map_layers_toggled",
  VISION_PROPOSAL_PHOTO_GALLERY_OPENED: "vision_proposal_photo_gallery_opened",
  VISION_PROPOSAL_PRICE_INFO_VIEWED: "vision_proposal_price_info_viewed",
  VISION_PROPOSAL_VISIT_STEP_ADVANCED: "vision_proposal_visit_step_advanced",
  VISION_PROPOSAL_COMPLETED: "vision_proposal_completed",
  VISION_PARTNER_DEMO_STARTED: "vision_partner_demo_started",
  VISION_PARTNER_DEMO_SEARCH_INITIATED: "vision_partner_demo_search_initiated",
  VISION_PARTNER_DEMO_SPACE_SELECTED: "vision_partner_demo_space_selected",
  VISION_PARTNER_DEMO_PROPOSAL_VIEWED: "vision_partner_demo_proposal_viewed",
  VISION_PARTNER_DEMO_BACK_TO_SEARCH: "vision_partner_demo_back_to_search",
  PROPOSAL_LICENSE_FEE_FORMAT_SELECTED: "proposal_license_fee_format_selected",
  PROPOSAL_LICENSE_FEE_VALUE_SET: "proposal_license_fee_value_set",
  PROPOSAL_TYPE_SELECTED: "proposal_type_selected",
  VISION_TICKET_REQUESTED: "vision_ticket_requested",
  VISION_AI_MODE_LOCATION_SPACE_ADDED_BY_ID:
    "vision_ai_mode_location_space_added_by_id",
  QUICK_SEARCH_USED: "quick_search_used",
  QUICK_SEARCH_RESULT_VIEWED: "quick_search_result_viewed",
};

export type PRODUCT_TYPE = "PO" | "MR" | "WS" | "EV";

export type DEFAULT_PROPERTIES = {
  product_type: PRODUCT_TYPE;
  url_page: string;
};

type CreateRoomProperties = {
  privateroom_id: number | string;
  space_id: number | string;
  user_id: number | string;
  email: string;
};

type UpdateRoomProperties = {
  privateroom_id: number | string;
  space_id: number | string;
  user_id: number | string;
  email: string;
};

type ViewPoDetailProperties = Record<string, unknown>;

type ViewPhotoProperties = Record<string, unknown>;

type SearchProperties = Record<string, unknown>;

type ClearSearchProperties = Record<string, unknown>;

type ShowMapProperties = {
  action: "open" | "close";
};

type AmenityCopiedProperties = {
  amenity_category: string;
  room_id: string | number;
};

type VisionAmenityCopiedProperties = {
  deal_id: string | null;
  amenity_category: string;
  room_id: string | number;
};

type VisionSearchResultsRenderedProperties = {
  deal_id: string | null;
  user_id?: string;
  email?: string;
  deal_url?: string | null;
  has_results: boolean;
  results_count: number;
  demands?: number;
  spaces_returned?: number;
  spaces_returned_ids?: number[];
  private_rooms_returned_ids?: string[] | number[];
  demands_without_results?: number;
  cities_returned?: string[];
  neighborhoods_returned?: string[];
  min_capacity_returned?: number;
  max_capacity_returned?: number;
  min_price_returned?: number;
  max_price_returned?: number;
  search_term?: string;
  search_type?: string;
  search_city_name?: string;
  search_latitude?: string;
  search_longitude?: string;
  filter_capacity_min?: number | null;
  filter_capacity_max?: number | null;
  filter_capacity_weight?: number | null;
  filter_price_min?: number | null;
  filter_price_max?: number | null;
  filter_price_weight?: number | null;
  filter_unit_credit_price?: number | null;
  filter_distance?: number;
  filter_amenities?: string[];
  filter_amenities_optional?: string[];
  filter_status?: number[];
  filter_skip_recent_updates?: boolean;
  city_name?: string;
  neighborhood?: string[] | string;
  location?: string;
  latitude?: string;
  longitude?: string;
  space_id?: number;
  private_office_ids?: number[] | null;
  capacity_min?: number | null;
  capacity_max?: number | null;
  capacity_weight?: number | null;
  price_min?: number | null;
  price_max?: number | null;
  price_weight?: number | null;
  unit_credit_price?: number | null;
  distance?: number;
  amenities?: string[];
  amenities_optional?: string[];
  status?: number[];
  skip_recent_updates_filter?: boolean;
  filters?: {
    term: string;
    minCapacity?: number;
    maxCapacity?: number;
    unitCreditPrice?: number;
    minPrice?: number;
    maxPrice?: number;
    amenitiesSlugs?: string[];
    distance?: number | string;
    minCapacityWeight?: number;
    maxCapacityWeight?: number;
    minPriceWeight?: number;
    maxPriceWeight?: number;
    unitCreditPriceWeight?: number;
  };
  type?: "single" | "multiple";
};

type AddressCopiedProperties = {
  room_id: string | number;
};

type NotesCopiedProperties = {
  room_id: string | number;
};

type ViewPageProperties = {
  room_id: string | number;
};

type ViewVipOfficePageProperties = {
  room_id: string | number;
  external_url: string;
};

type EditRoomProperties = {
  room_id: string | number;
};

type SelectRoomProperties = {
  room_id: string | number;
  element: "listing" | "drawer";
};

type SelectAllRoomProperties = Record<string, unknown>;

type ClickPrivateOfficeFilterProperties = {
  filter: string;
  value: { id: number; name: string } | { id: number; name: string }[];
};

type LoadedListPrivateOfficeProperties = {
  filters: {
    "roomId[]": string[];
    capacity: number[] | undefined;
    "neighborhood[]": string[] | undefined;
    cityName: string[] | undefined;
    creditPrice: number | undefined;
    status: number | undefined;
    value:
      | {
          id: number;
          name: string;
        }
      | undefined;
    spaceId: number[] | undefined;
    private_office_ids: string[] | undefined;
    creditsValue: number | undefined;
  };
};

type ClickPrivateOfficeProposalFinalProperties = {
  private_office_ids: number[];
  proposalLongUrl: string;
  dealUrl: string;
  filters: Record<string, string | string[]>;
};

type VisionClickPrivateOfficeProposalFinalProperties = {
  deal_id: string | null;
  private_office_ids: string[] | number[];
  proposalLongUrl: string;
};

type VisionClickPrivateOfficeProposalStartProperties = {
  deal_id: string | null;
  private_office_ids: string[] | number[];
};

type ClickPrivateOfficeProposalStartProperties = {
  private_office_ids: string[] | number[];
  filters: {
    cityName?: string[] | null;
    status?: number;
    capacity?: number[];
    creditsValue?: number;
    spaceName?: string;
    spaceId?: number[] | null;
    "roomId[]"?: string[] | null;
    latitude?: number | null;
    longitude?: number | null;
    "neighborhood[]"?: string[] | null;
  };
};

type EditOtherInfoProperties = {
  room_id: string | number;
};

type CreateNewRoomProperties = {
  entry_point: "menu" | "list_button";
};

type EditRoomModalSavedProperties = {
  room_id: string | number;
};

type PageViewProperties = {
  search: string;
  title: string;
};

type SearchCsvUploadProperties = {
  user_id: string;
  email: string;
};

type SearchCsvUploadFailProperties = {
  user_id: string;
  email: string;
  message: string;
};

type SearchCsvResultReturnedProperties = {
  user_id: string;
  email: string;
  demands: number;
  search_duration_ms: number;
  private_rooms_returned: number;
  spaces_returned: number;
  private_rooms_returned_ids: number[];
  spaces_returned_ids: number[];
  demands_without_results: number;
};

type SearchPromptSentProperties = {
  user_id: string;
  email: string;
  text: string;
};

type SearchPromptResultReturnedProperties = {
  user_id: string;
  email: string;
  text: string;
};

type SearchPromptResultFailProperties = {
  user_id: string;
  email: string;
  message: string;
};

type SearchResultsRenderedProperties = {
  user_id?: string;
  email?: string;
  deal_url?: string | null;
  has_results: boolean;
  results_count: number;
  demands?: number;
  spaces_returned?: number;
  spaces_returned_ids?: number[];
  private_rooms_returned_ids?: number[];
  demands_without_results?: number;
  cities_returned?: string[];
  neighborhoods_returned?: string[];
  min_capacity_returned?: number;
  max_capacity_returned?: number;
  min_price_returned?: number;
  max_price_returned?: number;
  search_term?: string;
  search_type?: string;
  search_city_name?: string;
  search_latitude?: string;
  search_longitude?: string;
  filter_capacity_min?: number | null;
  filter_capacity_max?: number | null;
  filter_capacity_weight?: number | null;
  filter_price_min?: number | null;
  filter_price_max?: number | null;
  filter_price_weight?: number | null;
  filter_unit_credit_price?: number | null;
  filter_distance?: number;
  filter_amenities?: string[];
  filter_amenities_optional?: string[];
  filter_status?: number[];
  filter_skip_recent_updates?: boolean;
  city_name?: string;
  neighborhood?: string[] | string;
  location?: string;
  latitude?: string;
  longitude?: string;
  space_id?: number;
  private_office_ids?: number[] | null;
  capacity_min?: number | null;
  capacity_max?: number | null;
  capacity_weight?: number | null;
  price_min?: number | null;
  price_max?: number | null;
  price_weight?: number | null;
  unit_credit_price?: number | null;
  distance?: number;
  amenities?: string[];
  amenities_optional?: string[];
  status?: number[];
  skip_recent_updates_filter?: boolean;
  filters?: {
    term: string;
    minCapacity?: number;
    maxCapacity?: number;
    unitCreditPrice?: number;
    minPrice?: number;
    maxPrice?: number;
    amenitiesSlugs?: string[];
    distance?: number | string;
    minCapacityWeight?: number;
    maxCapacityWeight?: number;
    minPriceWeight?: number;
    maxPriceWeight?: number;
    unitCreditPriceWeight?: number;
  };
  type?: "single" | "multiple";
};

type SearchButtonClickedProperties = {
  entry_point: "search_input";
  user_id: number | null;
  email: string | null;
  deal_url: string | null;
  filters: {
    minCapacity?: number;
    maxCapacity?: number;
    unitCreditPrice?: number;
    minPrice?: number;
    maxPrice?: number;
    amenitiesSlugs?: string[];
    distance?: number | string;
    minCapacityWeight?: number;
    maxCapacityWeight?: number;
    minPriceWeight?: number;
    maxPriceWeight?: number;
    unitCreditPriceWeight?: number;
    term?: string | null;
  };
};

type CreateProposalClickedProperties = {
  private_room_ids: string[];
  deal_url: string | null;
};

type VisionCreateProposalClickedProperties = {
  private_room_ids: string[];
  deal_id: string | null;
  origin: string;
  parent_long_list_id: string | null;
};

type ImportCsvButtonClickedProperties = {
  user_id: string | null;
  email: string | null;
  deal_url: string | null;
};

type ImportCsvSuccessProperties = {
  user_id: string | null;
  email: string | null;
  deal_url: string | null;
  demands_search: number;
};

type ImportCsvFailedProperties = {
  user_id: string | null;
  email: string | null;
  deal_url: string | null;
  error: string;
};

type CreateProposalFinishedProperties = {
  private_room_ids: string[];
  deal_url: string | null;
};

type VisionCreateProposalFinishedProperties = {
  private_room_ids: string[];
  deal_id: string | null;
};

type VisionLonglistFeedbackSubmittedProperties = {
  feedback: string;
  longlist_id: string;
  user_id: number | null;
  email: string | null;
  deal_id: string | null;
};

type VisionLonglistContinueClickedProperties = {
  longlist_id: string;
  user_id: number | null;
  email: string | null;
  deal_id: string | null;
  selected_count: number;
  total_count: number;
};

type VisionLonglistProposalStartProperties = {
  longlist_id: string;
  private_office_ids: string[];
  user_id: number | null;
  email: string | null;
  deal_id: string | null;
};

type ViewUpdateHistoryClickedProperties = {
  private_office_id: string;
  executed_by_user_id: number;
  room_id: string;
  room_name: string;
  space_id: number;
  space_name: string;
};

type SearchFilterAppliedProperties = {
  user_id: number | null;
  email: string | null;
  capacity_max?: number;
  capacity_min?: number;
  price_max?: number;
  price_min?: number;
  amenities: string[];
  amenities_optional?: string[];
  status?: string[];
  distance?: number;
  unit_credit_price?: number;
  capacity_weight?: number;
  price_weight?: number;
  skip_recent_updates_filter?: boolean;
};

type VisionSearchFilterAppliedProperties = {
  deal_id: string | null;
  user_id: number | null;
  email: string | null;
  capacity_max?: number;
  capacity_min?: number;
  price_max?: number;
  price_min?: number;
  amenities: string[];
  amenities_optional: string[];
  status?: string[];
  distance?: number;
  unit_credit_price?: number;
  capacity_weight?: number;
  price_weight?: number;
  skip_recent_updates_filter?: boolean;
};

type VisionSearchSubmittedProperties = {
  deal_id: string | null;
  user_id: number | null;
  email: string | null;
  search_type?: string;
  city_name?: string;
  neighborhood?: string[];
  location?: string;
  latitude?: string;
  longitude?: string;
  space_id?: number;
  private_office_ids?: string[] | number[] | null;
  capacity_min?: number | null;
  capacity_max?: number | null;
  capacity_weight?: number | null;
  positions_min?: number | string;
  positions_max?: number | string;
  price_min?: number | null;
  price_max?: number | null;
  price_weight?: number | null;
  unit_credit_price?: number | null;
  budget_min?: number | string;
  budget_max?: number | string;
  query?: string;
  property_type?: string[];
  is_furnished?: boolean;
  size_min?: number | string;
  size_max?: number | string;
  distance?: number;
  amenities?: string[];
  amenities_optional?: string[];
  status?: string[];
  skip_recent_updates_filter?: boolean;
};

type UpdateRoomAmenitiesProperties = {
  type: "request" | "response";
  room_id: number | string;
  space_id: number;
  amenities:
    | {
        status: string;
        name: string;
        id?: number | undefined;
        attributes?:
          | {
              name: string;
              contentType: string;
              id?: number | undefined;
              content?: string | undefined;
            }[]
          | undefined;
      }[]
    | GroupedAmenities[];
};

// Novos tipos para private room tracking
type PrivateRoomInfoStartedProperties = {
  user_id: number | string;
  email: string;
  flow_type: "create" | "edit";
  privateroom_id?: number | string;
  space_id?: number | string;
};

type PrivateRoomPhotoUploadStartedProperties = {
  user_id: number | string;
  email: string;
  flow_type: "create" | "edit";
};

type PrivateRoomPhotoUploadSuccessProperties = {
  user_id: number | string;
  email: string;
  flow_type: "create" | "edit";
};

type PrivateRoomPhotoUploadErrorProperties = {
  user_id: number | string;
  email: string;
  flow_type: "create" | "edit";
  error_message: string;
};

type PrivateRoomPhotoTagSelectedProperties = {
  user_id: number | string;
  email: string;
  flow_type: "create" | "edit";
  tag_label: string;
};

type CreateRoomErrorProperties = {
  user_id: number | string;
  email: string;
  space_id: number | string;
  error_message: string;
};

type UpdateRoomErrorProperties = {
  user_id: number | string;
  email: string;
  privateroom_id: number | string;
  space_id: number | string;
  error_message: string;
};

type DraftRoomSavedProperties = {
  user_id: number | string;
  email: string;
  privateroom_id: number | string;
  space_id: number | string;
};

type SaveDraftErrorProperties = {
  user_id: number | string;
  email: string;
  space_id: number | string;
  error_message: string;
};

type VisionProposalProperties = {
  email: string;
  proposal_id: string;
  user_agent: string;
  language: string;
  screen_resolution: string;
  timezone: string;
} & Partial<VisionProposalSharedContext>;

type VisionAIModeStartedProperties = {
  deal_id: string | null;
  user_id: number | null;
  email: string | null;
  has_previous_session: boolean;
  resumed_at_step: number;
};

/** Busca rápida ativada no AI-mode (PED-12650): auditoria de bypass do fluxo completo. */
type QuickSearchUsedProperties = {
  user_id: number | null;
  email: string | null;
};

/** Resultados da busca rápida exibidos (PED-12650): volume de uso vs. busca completa. */
type QuickSearchResultViewedProperties = {
  user_id: number | null;
  email: string | null;
  has_results: boolean;
  results_count: number;
  spaces_returned_ids: string[];
};

type VisionAIModeDiagnosisCompletedProperties = {
  deal_id: string | null;
  user_id: number | null;
  email: string | null;
  company_name: string;
  contact_name: string;
  contact_email: string;
  segment: string;
  target_city: string;
  positions_min: number | null;
  positions_max: number | null;
  monthly_budget: string | null;
  has_deal_imported: boolean;
  has_needs: boolean;
};

type VisionAIModeLocationCompletedProperties = {
  deal_id: string | null;
  user_id: number | null;
  email: string | null;
  company_name: string | null;
  location_label: string | null;
  radius_km: number | null;
  location_mode: "location" | "neighborhoods" | null;
  neighborhood_names: string[] | null;
  selected_spaces_count: number;
  selected_space_ids: string[];
  total_ranked_spaces: number;
  search_source?: "filters" | "search-and-rank" | "search";
  tolerance_capacity: number | null;
  tolerance_capacity_ignored: boolean;
  tolerance_price: number | null;
  tolerance_price_ignored: boolean;
  tolerance_distance_km: number | null;
  tolerance_distance_ignored: boolean;
};

type VisionAIModeAdjustmentsCompletedProperties = {
  deal_id: string | null;
  user_id: number | null;
  email: string | null;
  company_name: string | null;
  contract_months: number | null;
  credits_price: number;
  selected_spaces_count: number;
  recommended_spaces_count: number;
  avg_monthly_price: number;
  avg_setup_cost: number;
  avg_total: number;
  proposal_validity_date: string;
  has_seller_notes: boolean;
};

type VisionAIModeImagesCompletedProperties = {
  deal_id: string | null;
  user_id: number | null;
  email: string | null;
  company_name: string | null;
  selected_spaces_count: number;
  total_selected_images: number;
};

type VisionAIModeProposalGeneratedProperties = {
  deal_id: string | null;
  user_id: number | null;
  email: string | null;
  company_name: string | null;
  proposal_uuid: string;
  proposal_url: string;
  selected_spaces_count: number;
  selected_space_ids: string[];
  contract_months: number | null;
  avg_monthly_price: number;
  avg_setup_cost: number;
  avg_total: number;
  /** proposta_enviada_com_badge (PED-14095): rooms (not buildings) showing
   * an AVCB or alvará badge — a combo counts each of its rooms. */
  rooms_with_compliance_badge_count: number;
};

type VisionAIModeProposalLinkCopiedProperties = {
  deal_id: string | null;
  user_id: number | null;
  email: string | null;
  company_name: string | null;
  proposal_url: string;
};

type VisionAIModeProposalOpenedProperties = {
  deal_id: string | null;
  user_id: number | null;
  email: string | null;
  company_name: string | null;
  proposal_url: string;
};

type VisionAIModeStepBackProperties = {
  deal_id: string | null;
  user_id: number | null;
  email: string | null;
  from_step: number;
  from_step_name: string;
  to_step: number;
};

type VisionAIModeDealImportedProperties = {
  deal_id: string;
  user_id: number | null;
  email: string | null;
  company_name: string | null;
  city: string | null;
  positions_min: number | null;
  positions_max: number | null;
  has_summary_narrative: boolean;
  missing_fields: string[];
  extraction_status: "pending" | "ready" | "failed";
};

type VisionAIModeLocationFilterAppliedProperties = {
  deal_id: string | null;
  user_id: number | null;
  email: string | null;
  location_label: string | null;
  radius_km: number | null;
  capacity_min: number | null;
  capacity_max: number | null;
  credits_value: number | null;
  price_min: number | null;
  price_max: number | null;
};

type VisionAIModeSpaceDetailsViewedProperties = {
  deal_id: string | null;
  user_id: number | null;
  email: string | null;
  room_id: string;
  room_name: string;
  room_search_id: number | null;
  space_id: string;
  space_name: string;
  space_score: number;
  space_city: string;
  space_monthly_price: number | null;
  space_capacity: number;
};

type VisionAIModeSpaceScoreViewedProperties = {
  deal_id: string | null;
  user_id: number | null;
  email: string | null;
  space_id: string;
  space_name: string;
  space_score: number;
};

type VisionAIModeViewModeChangedProperties = {
  deal_id: string | null;
  user_id: number | null;
  email: string | null;
  view_mode: "photos" | "map";
};

type VisionAIModeLocationSearchStartedProperties = {
  deal_id: string | null;
  user_id: number | null;
  email: string | null;
  timestamp: string;
  location_label?: string | null;
  radius_km?: number | null;
  capacity_min?: number | null;
  capacity_max?: number | null;
  credits_value?: number | null;
  price_min?: number | null;
  price_max?: number | null;
  is_retry?: boolean;
  search_source?: "filters" | "search-and-rank" | "search";
  tolerance_capacity?: number;
  tolerance_price?: number;
  tolerance_distance?: number;
};

type VisionAIModeLocationSearchResultProperties = {
  deal_id: string | null;
  user_id: number | null;
  email: string | null;
  timestamp: string;
  duration_ms: number | null;
  results_count?: number;
  search_source?: "filters" | "search-and-rank" | "search";
  tolerance_capacity?: number;
  tolerance_price?: number;
  tolerance_distance?: number;
};

type VisionAIModeSearchResultsRenderedProperties = {
  deal_id: string | null;
  user_id: number | null;
  email: string | null;
  timestamp: string;
  duration_ms: number | null;
  search_source?: "filters" | "search-and-rank" | "search";
  has_results: boolean;
  results_count: number;
  matched_count: number;
  matched_space_ids: string[];
  matched_spaces: Array<{
    id: string;
    space_name: string;
    room_name: string;
    score: number;
    capacity: number;
    monthly_price: number | null;
  }>;
  filter_location_label: string | null;
  filter_location_lat: number | null;
  filter_location_lng: number | null;
  filter_radius_km: number | null;
  filter_capacity_min: number | null;
  filter_capacity_max: number | null;
  filter_credits_value: number | null;
  filter_price_min: number | null;
  filter_price_max: number | null;
  filter_location_mode: "location" | "neighborhoods";
  filter_city_name: string | null;
  filter_neighborhood_names: string[] | null;
};

type VisionAIModeLocationSearchNoMatchProperties = {
  deal_id: string | null;
  user_id: number | null;
  email: string | null;
  results_count: number;
  score_threshold: number;
  filters: {
    location_label: string | null;
    radius_km: number | null;
    capacity_min: number | null;
    capacity_max: number | null;
    credits_value: number | null;
    price_min: number | null;
    price_max: number | null;
    location_mode: "location" | "neighborhoods";
    neighborhood_names: string[] | null;
  };
};

type VisionAIModeProposalEditStartedProperties = {
  proposal_uuid: string;
  user_id: number | null;
  email: string | null;
  version_number: number | null;
};

type VisionAIModeProposalEditSavedProperties = {
  proposal_uuid: string;
  company_name: string | null;
  new_version_number: number | null;
  no_changes: boolean;
  changes_count?: number;
};

type VisionAIModeProposalEditConflictProperties = {
  proposal_uuid: string;
  company_name?: string | null;
  current_version: number;
  expected_version?: number | null;
};

// Shared context sent on every SMB proposal event (Proposta 2.0 taxonomy).
// Partial<> on the existing event types below because the legacy proposal
// page fires the same event keys without this context — the SMB
// ProposalTrackingProvider is what guarantees the full set is sent there.
export type VisionProposalSharedContext = {
  proposal_uuid: string;
  deal_id: string | null;
  device: "mobile" | "desktop";
  client_segment: string | null;
  /** "ENT" | "SMB", null for legacy/untyped payloads — PED-12653: both types
   * share the standard template and funnel, segmented by this property. */
  proposal_type: string | null;
};

// Room-scoped context: posicao_no_ranking is the ORIGINAL algorithm position
// (index in suggestedSpaces before any user re-sorting); offer_variant has no
// backend source yet and is always null until the API provides it.
export type VisionProposalRoomContext = VisionProposalSharedContext & {
  espaco_id: string;
  partner_id: number | null;
  posicao_no_ranking: number | null;
  offer_variant: string | null;
  combo_id: string | null;
};

type VisionProposalVisitsScheduledProperties = {
  proposal_uuid: string;
  deal_id: string | null;
  // Shared context — always sent by the SMB provider; the legacy proposal
  // page sends device/client_segment explicitly since the ranking backfill.
  device?: "mobile" | "desktop";
  client_segment?: string | null;
  room_ids: string[];
  visits: Array<{
    room_id: string;
    room_name: string;
    room_address: string;
    date: string;
    time: string;
    // Ranking context at conversion. Optional: absent on legacy proposals
    // persisted before the room-context rollout.
    espaco_id?: string;
    partner_id?: number | null;
    posicao_no_ranking?: number | null;
    offer_variant?: string | null;
    combo_id?: string | null;
    /** Visit format — the tracking plan's "tipo" read on this event. Absent
     * on the legacy proposal page (`ScheduleModal`), which has no format
     * picker; the SMB page always sends it. */
    modality?: "online" | "in_person" | "test_drive";
  }>;
  occurred_at: string;
} & Partial<Omit<VisionProposalSharedContext, "proposal_uuid" | "deal_id">>;

/** PED-12892 hypothesis measurement (tracking plan: DAY_USE_SELECTED) —
 * fired when the client picks the test-drive modality for a room, once per
 * room per session. Selection is the signal the funnel needs (it also
 * captures who picks it and gives up, e.g. blocked by the single-room
 * lock); the confirmed request is read from
 * vision_proposal_visits_scheduled's `modality` instead. */
type VisionProposalDayUseSelectedProperties = VisionProposalRoomContext;

type VisionProposalSpaceSelectedProperties = {
  proposal_id: string;
  deal_id: string | null;
  email: string | null;
  room_id: string;
  room_name: string | null;
  room_address: string | null;
  room_capacity: number | null;
  monthly_price: number | null;
} & Partial<VisionProposalRoomContext>;

type VisionProposalTabViewedProperties = {
  proposal_id: string;
  deal_id: string | null;
  email: string | null;
  // fotos/mapa/amenidades/chat are the legacy proposal page's tabs;
  // office/space are the SMB page's RoomSpecTabs (Proposta 2.0 taxonomy).
  tab: "fotos" | "mapa" | "amenidades" | "chat" | "office" | "space";
  office_index?: number | null;
  room_id: string;
  room_name: string | null;
} & Partial<VisionProposalRoomContext>;

type VisionProposalSpaceRatedProperties = {
  proposal_id: string;
  deal_id: string | null;
  email: string | null;
  room_id: string;
  room_name: string | null;
  rating: "up" | "down";
  reasons: string[];
  sub_reasons: string[];
  has_comment: boolean;
  // Optional free text: the SMB page sends it (Proposta 2.0 taxonomy), the
  // legacy page does not.
  comment?: string | null;
  // "briefing": a thumb given inside the briefing aprofundado's per-room
  // rating (PED-14307) — same `rateSpace` as the listing, told apart here.
  context: "proposal" | "visit_scheduled" | "briefing";
  combo_id: string | null;
} & Partial<VisionProposalRoomContext>;

type VisionProposalSpaceRatingOpenedProperties = {
  proposal_id: string;
  deal_id: string | null;
  email: string | null;
  room_id: string;
  room_name: string | null;
  rating: "up" | "down";
  combo_id: string | null;
} & Partial<VisionProposalRoomContext>;

type VisionProposalSpaceRatingAbandonedProperties = {
  proposal_id: string;
  deal_id: string | null;
  email: string | null;
  room_id: string;
  room_name: string | null;
  rating: "up" | "down";
  combo_id: string | null;
} & Partial<VisionProposalRoomContext>;

type VisionProposalScheduleVisitClickedProperties = {
  proposal_id: string;
  deal_id: string | null;
  email: string | null;
  room_id: string;
  room_name: string | null;
} & Partial<VisionProposalRoomContext>;

type VisionProposalChatMessageSentProperties = {
  proposal_id: string;
  deal_id: string | null;
  email: string | null;
  room_id: string;
  room_name: string | null;
  message_length: number;
  is_chip: boolean;
} & Partial<VisionProposalRoomContext>;

// Proposta 2.0 (SMB) events — see the tracking taxonomy doc linked in
// PED-12855. All fired exclusively by the SMB proposal page through
// ProposalTrackingProvider, which supplies the shared/room context.

type VisionProposalCardPhotoBrowsedProperties = VisionProposalRoomContext & {
  email: string | null;
  room_name: string | null;
  photos_count: number | null;
  card_context: "grid" | "map_strip";
};

type VisionProposalTalkToBiaClickedProperties =
  Partial<VisionProposalSharedContext> & {
    email: string | null;
    consultant_name: string;
    placement: "top_bar" | "cover";
  };

type VisionProposalMapDistanceCalculatedProperties =
  VisionProposalRoomContext & {
    email: string | null;
    room_name: string | null;
    reference_address: string;
    distance_km: number | null;
    resolved: boolean;
  };

type VisionProposalMapViewedProperties = VisionProposalSharedContext & {
  email: string | null;
  trigger: "mobile_map_button" | "desktop_inline";
};

type VisionProposalStepAdvancedProperties = VisionProposalSharedContext & {
  email: string | null;
  from_step: string;
  to_step: string;
  from_step_index: number;
  to_step_index: number;
  direction: "forward" | "back";
};

type VisionProposalMapPoiFilteredProperties = VisionProposalSharedContext & {
  email: string | null;
  selected_categories: string[];
  source: "overview_map" | "room_map";
};

type VisionProposalAbandonedProperties = VisionProposalSharedContext & {
  email: string | null;
  time_on_page_ms: number;
  last_step: string;
  interacted: boolean;
  trigger: "visibility_hidden" | "pagehide";
};

type VisionProposalSpaceQuestionProperties = VisionProposalRoomContext & {
  email: string | null;
  room_name: string | null;
  is_chip: boolean;
  theme: string | null;
  question_text: string | null;
  message_length: number;
};

type VisionProposalShowcaseReorderedProperties = VisionProposalSharedContext & {
  email: string | null;
  sort_mode: string;
  previous_sort_mode: string;
};

type VisionProposalShowcaseFilteredProperties = VisionProposalSharedContext & {
  email: string | null;
  filter_type: "capacity" | "price" | "size";
  bucket_key: string;
  selected: boolean;
  selected_buckets: string[];
};

type VisionProposalShowcaseScrolledProperties = VisionProposalSharedContext & {
  email: string | null;
  depth_pct: 25 | 50 | 75 | 100;
  last_room_index_reached: number | null;
};

type VisionProposalValuePropViewedProperties = VisionProposalSharedContext & {
  email: string | null;
  time_on_screen_ms: number;
  scrolled: boolean;
  advanced: boolean;
};

type VisionProposalValueModeToggledProperties =
  Partial<VisionProposalSharedContext> & {
    email: string | null;
    mode: "traditional" | "woba";
    previous_mode: "traditional" | "woba";
  };

type VisionProposalHoursInfoViewedProperties = VisionProposalSharedContext & {
  email: string | null;
};

type VisionProposalViewModeToggledProperties = VisionProposalSharedContext & {
  email: string | null;
  view_mode: "cards" | "list";
  previous_view_mode: "cards" | "list";
};

type VisionProposalMapLayersToggledProperties = VisionProposalSharedContext & {
  email: string | null;
  action: "opened" | "mode_toggled";
  map_3d: boolean | null;
  source: "overview_map" | "room_map";
};

type VisionProposalPhotoGalleryOpenedProperties = VisionProposalRoomContext & {
  email: string | null;
  room_name: string | null;
  source: "carousel_expand";
};

type VisionProposalPriceInfoViewedProperties = VisionProposalRoomContext & {
  email: string | null;
  room_name: string | null;
  info_type: "credits" | "price_breakdown";
  context: "card" | "drawer";
};

type VisionProposalVisitStepAdvancedProperties = VisionProposalSharedContext & {
  email: string | null;
  from_sub_step: "when" | "data";
  to_sub_step: "when" | "data";
  direction: "forward" | "back";
};

type VisionProposalCompletedProperties = VisionProposalSharedContext & {
  email: string | null;
  visits_count: number;
  room_ids: string[];
  occurred_at: string;
};

// "Agendar visita" flow (proposal-standard) — same funnel-instrumentation idea as
// the "Fazer proposta" events below: entry point, each substep transition,
// so drop-off is measurable. Final submission already had its own events
// (VISION_PROPOSAL_VISITS_SCHEDULED/VISION_PROPOSAL_TESTDRIVE_REQUESTED,
// further down) — these three fill in everything before that.
type VisionProposalVisitFlowStartedProperties = VisionProposalSharedContext & {
  email: string | null;
  room_ids: string[];
  /** Which CTA opened the flow — the listing's own "Solicitar visita", or
   * the room details drawer's "Agendar visita". */
  entry_point: "listing" | "drawer";
};

type VisionProposalVisitWhenCompletedProperties =
  VisionProposalSharedContext & {
    email: string | null;
    room_ids: string[];
    modalities: Array<{ room_id: string; modality: string }>;
    has_test_drive: boolean;
  };

type VisionProposalVisitBackToWhenProperties = VisionProposalSharedContext & {
  email: string | null;
  room_ids: string[];
};

// "Fazer proposta" flow (proposal-standard) — one event per screen transition/
// choice, hub through submission, so the whole funnel (and where clients
// drop off) is measurable end to end.
type VisionProposalMakeProposalStartedProperties =
  VisionProposalSharedContext & {
    email: string | null;
    room_ids: string[];
    /** Which CTA opened the flow — the listing's own secondary button, or the
     * room details drawer's "Fazer proposta". */
    entry_point: "listing" | "drawer";
  };

type VisionProposalConditionsChoiceSelectedProperties =
  VisionProposalSharedContext & {
    email: string | null;
    room_ids: string[];
    choice: "accept" | "negotiate";
  };

type VisionProposalValueNegotiatedProperties = VisionProposalSharedContext & {
  email: string | null;
  room_ids: string[];
  original_value: number;
  negotiated_value: number;
  discount_percent: number;
  has_reason: boolean;
  reason_length: number;
};

type VisionProposalAdjustmentsChoiceSelectedProperties =
  VisionProposalSharedContext & {
    email: string | null;
    room_ids: string[];
    choice: "none" | "some";
  };

type VisionProposalAdjustmentTypeSelectedProperties =
  VisionProposalSharedContext & {
    email: string | null;
    room_ids: string[];
    adjustment_type: "layout" | "maintenance" | "positions";
  };

type VisionProposalAdjustmentAddedProperties = VisionProposalSharedContext & {
  email: string | null;
  room_ids: string[];
  adjustment_type: "layout" | "maintenance" | "positions";
  description_length: number;
  total_adjustments: number;
};

type VisionProposalAdjustmentRemovedProperties = VisionProposalSharedContext & {
  email: string | null;
  room_ids: string[];
  adjustment_type: "layout" | "maintenance" | "positions";
  total_adjustments: number;
};

// Fills the one gap in the funnel above — "review" (Identificação, step 3
// of the 3-step stepper) is reachable from 3 different choice paths with no
// shared "arrived" signal otherwise. See `trackProposalIdentificationReached`
// in ProposalPage.tsx for the full reasoning.
type VisionProposalIdentificationReachedProperties =
  VisionProposalSharedContext & {
    email: string | null;
    room_ids: string[];
  };

type VisionProposalSubmittedProperties = VisionProposalSharedContext & {
  email: string | null;
  room_ids: string[];
  /** The requester filled in on the review screen — can differ from the
   * gate `email` the provider stamps on every event. */
  requester_email: string | null;
  original_value: number;
  final_value: number;
  is_negotiating: boolean;
  /** ENT only (PED-12653): the flex-credits R$/mês ask on the table — the
   * proposal's own value unless the client adjusted it; null for SMB. */
  flex_credits_value: number | null;
  flex_credits_adjusted: boolean;
  adjustment_types: string[];
  adjustments_count: number;
  occupancy_date: string;
  contract_term_months: number | null;
};

// "Briefing aprofundado" (PED-14146) — same shared context as the rest of
// the "Fazer proposta" funnel (`email` included, auto-injected by the
// provider like every other proposal event). No room_ids: the card isn't
// tied to any specific listed space (the room the client liked, when there
// is one, travels as `liked_space_id` on SUBMITTED).
/** The card scrolled into view — the top of the funnel, so STARTED reads as
 * a click-through rate instead of an absolute count. Once per page load
 * (the card renders in both the grid and the list layouts). */
type VisionProposalBriefingCardViewedProperties =
  VisionProposalSharedContext & {
    /** Which of the two cards was shown. */
    flow: string;
  };

type VisionProposalBriefingStartedProperties = VisionProposalSharedContext & {
  /** "smallTeam" (até 30 posições) | "largeTeam" (31 ou mais) —
   * which of the two cards the client clicked. */
  flow: string;
};

/** One per screen transition, so drop-off per stage is measurable. */
type VisionProposalBriefingStepAdvancedProperties =
  VisionProposalSharedContext & {
    flow: string;
    from_step: string;
    to_step: string;
  };

type VisionProposalBriefingSubmittedProperties = VisionProposalSharedContext & {
  /** How many answers were filled — engagement signal. */
  filled_fields_count: number;
  flow: string;
  /** Where the answers routed: "ready" | "customizable" | "tailorMade" —
   * the funnel's own view of what the Zap will do with the ticket. */
  pipeline: string;
  /** Question 00's answer — both sizes get the question now, so this is
   * never null once the briefing is submitted. */
  intent: string | null;
  /** Whether any requested change touches the shell — what escalates a
   * Pronto request to Personalizável. */
  adjustments_structural: boolean;
  liked_space_id: string | null;
};

type OutlierDialogViewedProperties = {
  reason: string;
  outlier_type: string;
};

type OutlierDialogConfirmedProperties = {
  reason: string;
  outlier_type: string;
};

type OutlierDialogCancelledProperties = {
  reason: string;
  outlier_type: string;
};

type ProposalLicenseFeeFormatSelectedProperties = {
  deal_id: string | null;
  user_id: number | null;
  email: string | null;
  format: "percentage" | "fixed";
};

type ProposalTypeSelectedProperties = {
  deal_id: string | null;
  user_id: number | null;
  email: string | null;
  proposal_type: "ENT" | "SMB";
};

type ProposalLicenseFeeValueSetProperties = {
  deal_id: string | null;
  user_id: number | null;
  email: string | null;
  format: "percentage" | "fixed";
  percentage_value: number | null;
  fixed_value: number | null;
  calculated_value: number;
  avg_room_price: number;
  rooms_count: number;
};

export type EVENTS_PROPERTIES = {
  OUTLIER_DIALOG_VIEWED: OutlierDialogViewedProperties;
  OUTLIER_DIALOG_CONFIRMED: OutlierDialogConfirmedProperties;
  OUTLIER_DIALOG_CANCELLED: OutlierDialogCancelledProperties;
  CREATE_ROOM_SUCCESS: CreateRoomProperties;
  UPDATE_ROOM_SUCCESS: UpdateRoomProperties;
  VIEW_PO_DETAIL_CLICKED: ViewPoDetailProperties;
  VIEW_PHOTO_CLICKED: ViewPhotoProperties;
  SEARCH_CLICKED: SearchProperties;
  CLEAR_SEARCH_CLICKED: ClearSearchProperties;
  SHOW_MAP_CLICKED: ShowMapProperties;
  AMENITY_CLICKED: AmenityCopiedProperties;
  ADDRESS_COPIED: AddressCopiedProperties;
  NOTES_COPIED: NotesCopiedProperties;
  VIEW_PAGE_CLICKED: ViewPageProperties;
  VIEW_VIP_OFFICE_PAGE_CLICKED: ViewVipOfficePageProperties;
  EDIT_ROOM_CLICKED: EditRoomProperties;
  SELECT_ROOM_CLICKED: SelectRoomProperties;
  SELECT_ALL_ROOM_CLICKED: SelectAllRoomProperties;
  CLICK_PRIVATEOFFICE_FILTER: ClickPrivateOfficeFilterProperties;
  LOADED_LIST_PRIVATEOFFICE: LoadedListPrivateOfficeProperties;
  CLICK_PRIVATEOFFICE_PROPOSAL_FINAL: ClickPrivateOfficeProposalFinalProperties;
  CLICK_PRIVATEOFFICE_PROPOSAL_START: ClickPrivateOfficeProposalStartProperties;
  VISION_CLICK_PRIVATEOFFICE_PROPOSAL_FINAL: VisionClickPrivateOfficeProposalFinalProperties;
  VISION_CLICK_PRIVATEOFFICE_PROPOSAL_START: VisionClickPrivateOfficeProposalStartProperties;
  EDIT_OTHER_INFO_CLICKED: EditOtherInfoProperties;
  CREATE_NEW_ROOM_CLICKED: CreateNewRoomProperties;
  EDIT_ROOM_MODAL_SAVED: EditRoomModalSavedProperties;
  PAGE_VIEW: PageViewProperties;
  SEARCH_CSV_UPLOAD: SearchCsvUploadProperties;
  SEARCH_CSV_UPLOAD_FAIL: SearchCsvUploadFailProperties;
  SEARCH_CSV_RESULT_RETURNED: SearchCsvResultReturnedProperties;
  SEARCH_PROMPT_SENT: SearchPromptSentProperties;
  SEARCH_PROMPT_RESULT_RETURNED: SearchPromptResultReturnedProperties;
  SEARCH_PROMPT_RESULT_FAIL: SearchPromptResultFailProperties;
  SEARCH_BUTTON_CLICKED: SearchButtonClickedProperties;
  SEARCH_SUBMITTED: SearchButtonClickedProperties;
  SEARCH_RESULTS_RENDERED: SearchResultsRenderedProperties;
  CREATE_PROPOSAL_CLICKED: CreateProposalClickedProperties;
  VISION_CREATE_PROPOSAL_CLICKED: VisionCreateProposalClickedProperties;
  IMPORT_CSV_BUTTON_CLICKED: ImportCsvButtonClickedProperties;
  IMPORT_CSV_SUCCESS: ImportCsvSuccessProperties;
  IMPORT_CSV_FAILED: ImportCsvFailedProperties;
  CREATE_PROPOSAL_FINISHED: CreateProposalFinishedProperties;
  VISION_CREATE_PROPOSAL_FINISHED: VisionCreateProposalFinishedProperties;
  VIEW_UPDATE_HISTORY_CLICKED: ViewUpdateHistoryClickedProperties;
  SEARCH_FILTER_APPLIED: SearchFilterAppliedProperties;
  UPDATE_ROOM_AMENITIES: UpdateRoomAmenitiesProperties;
  PRIVATE_ROOM_INFO_STARTED: PrivateRoomInfoStartedProperties;
  PRIVATE_ROOM_PHOTO_UPLOAD_STARTED: PrivateRoomPhotoUploadStartedProperties;
  PRIVATE_ROOM_PHOTO_UPLOAD_SUCCESS: PrivateRoomPhotoUploadSuccessProperties;
  PRIVATE_ROOM_PHOTO_UPLOAD_ERROR: PrivateRoomPhotoUploadErrorProperties;
  PRIVATE_ROOM_PHOTO_TAG_SELECTED: PrivateRoomPhotoTagSelectedProperties;
  CREATE_ROOM_ERROR: CreateRoomErrorProperties;
  UPDATE_ROOM_ERROR: UpdateRoomErrorProperties;
  DRAFT_ROOM_SAVED: DraftRoomSavedProperties;
  SAVE_DRAFT_ERROR: SaveDraftErrorProperties;
  VISION_SEARCH_FILTER_APPLIED: VisionSearchFilterAppliedProperties;
  VISION_SEARCH_SUBMITTED: VisionSearchSubmittedProperties;
  VISION_AMENITY_CLICKED: VisionAmenityCopiedProperties;
  VISION_SEARCH_RESULTS_RENDERED: VisionSearchResultsRenderedProperties;
  VISION_LONGLIST_FEEDBACK_SUBMITTED: VisionLonglistFeedbackSubmittedProperties;
  VISION_LONGLIST_CONTINUE_CLICKED: VisionLonglistContinueClickedProperties;
  VISION_LONGLIST_PROPOSAL_START: VisionLonglistProposalStartProperties;
  VISION_PROPOSAL: VisionProposalProperties;
  VISION_AI_MODE_STARTED: VisionAIModeStartedProperties;
  VISION_AI_MODE_DIAGNOSIS_COMPLETED: VisionAIModeDiagnosisCompletedProperties;
  VISION_AI_MODE_LOCATION_COMPLETED: VisionAIModeLocationCompletedProperties;
  VISION_AI_MODE_ADJUSTMENTS_COMPLETED: VisionAIModeAdjustmentsCompletedProperties;
  VISION_AI_MODE_IMAGES_COMPLETED: VisionAIModeImagesCompletedProperties;
  VISION_AI_MODE_PROPOSAL_GENERATED: VisionAIModeProposalGeneratedProperties;
  VISION_AI_MODE_PROPOSAL_LINK_COPIED: VisionAIModeProposalLinkCopiedProperties;
  VISION_AI_MODE_PROPOSAL_OPENED: VisionAIModeProposalOpenedProperties;
  VISION_AI_MODE_STEP_BACK: VisionAIModeStepBackProperties;
  VISION_AI_MODE_DEAL_IMPORTED: VisionAIModeDealImportedProperties;
  VISION_AI_MODE_LOCATION_FILTER_APPLIED: VisionAIModeLocationFilterAppliedProperties;
  VISION_AI_MODE_SPACE_DETAILS_VIEWED: VisionAIModeSpaceDetailsViewedProperties;
  VISION_AI_MODE_SPACE_SCORE_VIEWED: VisionAIModeSpaceScoreViewedProperties;
  VISION_AI_MODE_VIEW_MODE_CHANGED: VisionAIModeViewModeChangedProperties;
  VISION_AI_MODE_LOCATION_SEARCH_STARTED: VisionAIModeLocationSearchStartedProperties;
  VISION_AI_MODE_LOCATION_SEARCH_SUCCESS: VisionAIModeLocationSearchResultProperties;
  VISION_AI_MODE_LOCATION_SEARCH_NO_RESULTS: VisionAIModeLocationSearchResultProperties;
  VISION_AI_MODE_LOCATION_SEARCH_ERROR: VisionAIModeLocationSearchResultProperties;
  VISION_AI_MODE_LOCATION_SEARCH_NO_MATCH: VisionAIModeLocationSearchNoMatchProperties;
  VISION_AI_MODE_SEARCH_RESULTS_RENDERED: VisionAIModeSearchResultsRenderedProperties;
  VISION_AI_MODE_PROPOSAL_EDIT_STARTED: VisionAIModeProposalEditStartedProperties;
  VISION_AI_MODE_PROPOSAL_EDIT_SAVED: VisionAIModeProposalEditSavedProperties;
  VISION_AI_MODE_PROPOSAL_EDIT_CONFLICT: VisionAIModeProposalEditConflictProperties;
  VISION_PROPOSAL_VISIT_FLOW_STARTED: VisionProposalVisitFlowStartedProperties;
  VISION_PROPOSAL_VISIT_WHEN_COMPLETED: VisionProposalVisitWhenCompletedProperties;
  VISION_PROPOSAL_VISIT_BACK_TO_WHEN: VisionProposalVisitBackToWhenProperties;
  VISION_PROPOSAL_VISITS_SCHEDULED: VisionProposalVisitsScheduledProperties;
  VISION_PROPOSAL_SPACE_SELECTED: VisionProposalSpaceSelectedProperties;
  VISION_PROPOSAL_TAB_VIEWED: VisionProposalTabViewedProperties;
  VISION_PROPOSAL_SPACE_RATED: VisionProposalSpaceRatedProperties;
  VISION_PROPOSAL_SPACE_RATING_OPENED: VisionProposalSpaceRatingOpenedProperties;
  VISION_PROPOSAL_SPACE_RATING_ABANDONED: VisionProposalSpaceRatingAbandonedProperties;
  VISION_PROPOSAL_SCHEDULE_VISIT_CLICKED: VisionProposalScheduleVisitClickedProperties;
  VISION_PROPOSAL_DAY_USE_SELECTED: VisionProposalDayUseSelectedProperties;
  VISION_PROPOSAL_CHAT_MESSAGE_SENT: VisionProposalChatMessageSentProperties;
  VISION_PROPOSAL_MAKE_PROPOSAL_STARTED: VisionProposalMakeProposalStartedProperties;
  VISION_PROPOSAL_CONDITIONS_CHOICE_SELECTED: VisionProposalConditionsChoiceSelectedProperties;
  VISION_PROPOSAL_VALUE_NEGOTIATED: VisionProposalValueNegotiatedProperties;
  VISION_PROPOSAL_ADJUSTMENTS_CHOICE_SELECTED: VisionProposalAdjustmentsChoiceSelectedProperties;
  VISION_PROPOSAL_ADJUSTMENT_TYPE_SELECTED: VisionProposalAdjustmentTypeSelectedProperties;
  VISION_PROPOSAL_ADJUSTMENT_ADDED: VisionProposalAdjustmentAddedProperties;
  VISION_PROPOSAL_ADJUSTMENT_REMOVED: VisionProposalAdjustmentRemovedProperties;
  VISION_PROPOSAL_IDENTIFICATION_REACHED: VisionProposalIdentificationReachedProperties;
  VISION_PROPOSAL_SUBMITTED: VisionProposalSubmittedProperties;
  VISION_PROPOSAL_BRIEFING_CARD_VIEWED: VisionProposalBriefingCardViewedProperties;
  VISION_PROPOSAL_BRIEFING_STARTED: VisionProposalBriefingStartedProperties;
  VISION_PROPOSAL_BRIEFING_STEP_ADVANCED: VisionProposalBriefingStepAdvancedProperties;
  VISION_PROPOSAL_BRIEFING_SUBMITTED: VisionProposalBriefingSubmittedProperties;
  VISION_PROPOSAL_CARD_PHOTO_BROWSED: VisionProposalCardPhotoBrowsedProperties;
  VISION_PROPOSAL_TALK_TO_BIA_CLICKED: VisionProposalTalkToBiaClickedProperties;
  VISION_PROPOSAL_MAP_DISTANCE_CALCULATED: VisionProposalMapDistanceCalculatedProperties;
  VISION_PROPOSAL_MAP_VIEWED: VisionProposalMapViewedProperties;
  VISION_PROPOSAL_STEP_ADVANCED: VisionProposalStepAdvancedProperties;
  VISION_PROPOSAL_MAP_POI_FILTERED: VisionProposalMapPoiFilteredProperties;
  VISION_PROPOSAL_ABANDONED: VisionProposalAbandonedProperties;
  VISION_PROPOSAL_SPACE_QUESTION: VisionProposalSpaceQuestionProperties;
  VISION_PROPOSAL_SHOWCASE_REORDERED: VisionProposalShowcaseReorderedProperties;
  VISION_PROPOSAL_SHOWCASE_FILTERED: VisionProposalShowcaseFilteredProperties;
  VISION_PROPOSAL_SHOWCASE_SCROLLED: VisionProposalShowcaseScrolledProperties;
  VISION_PROPOSAL_VALUE_PROP_VIEWED: VisionProposalValuePropViewedProperties;
  VISION_PROPOSAL_VALUE_MODE_TOGGLED: VisionProposalValueModeToggledProperties;
  VISION_PROPOSAL_HOURS_INFO_VIEWED: VisionProposalHoursInfoViewedProperties;
  VISION_PROPOSAL_VIEW_MODE_TOGGLED: VisionProposalViewModeToggledProperties;
  VISION_PROPOSAL_MAP_LAYERS_TOGGLED: VisionProposalMapLayersToggledProperties;
  VISION_PROPOSAL_PHOTO_GALLERY_OPENED: VisionProposalPhotoGalleryOpenedProperties;
  VISION_PROPOSAL_PRICE_INFO_VIEWED: VisionProposalPriceInfoViewedProperties;
  VISION_PROPOSAL_VISIT_STEP_ADVANCED: VisionProposalVisitStepAdvancedProperties;
  VISION_PROPOSAL_COMPLETED: VisionProposalCompletedProperties;
  VISION_PARTNER_DEMO_STARTED: Record<string, unknown>;
  VISION_PARTNER_DEMO_SEARCH_INITIATED: Record<string, unknown>;
  VISION_PARTNER_DEMO_SPACE_SELECTED: Record<string, unknown>;
  VISION_PARTNER_DEMO_PROPOSAL_VIEWED: Record<string, unknown>;
  VISION_PARTNER_DEMO_BACK_TO_SEARCH: Record<string, unknown>;
  PROPOSAL_LICENSE_FEE_FORMAT_SELECTED: ProposalLicenseFeeFormatSelectedProperties;
  PROPOSAL_LICENSE_FEE_VALUE_SET: ProposalLicenseFeeValueSetProperties;
  PROPOSAL_TYPE_SELECTED: ProposalTypeSelectedProperties;
  VISION_TICKET_REQUESTED: Record<string, unknown>;
  VISION_AI_MODE_LOCATION_SPACE_ADDED_BY_ID: {
    deal_id: string | null;
    user_id: number | null;
    room_id: string;
    found: boolean;
  };
  QUICK_SEARCH_USED: QuickSearchUsedProperties;
  QUICK_SEARCH_RESULT_VIEWED: QuickSearchResultViewedProperties;
};

export type SearchPrivateRoomEventType =
  | "SEARCH_BUTTON_CLICKED"
  | "SEARCH_SUBMITTED";
